import { Box, Text, Flex, Image } from "@chakra-ui/react";
import HomeIcon from "./assets/home.png";
import GoIcon from "./assets/go.png";
import { useNavigate } from "react-router-dom";

const BankCard = ({
  bank,
  bankIndex,
  onClick,
}: {
  bank: any;
  bankIndex: number;
  onClick: () => void;
}) => {
  return (
    <Flex
      sx={{
        width: "100%",
        height: "170px",
        background: "#fff",
        borderRadius: "10px",
        overflow: "hidden",
        paddingTop: "16px",
        border: "1px solid #D8762B",
      }}
      flexDir={"column"}
      align={"center"}
      onClick={onClick}
    >
      <Text
        sx={{
          color: "#D8762B",
          textAlign: "center",
          fontFamily: "DIN-Black",
          fontSize: "14px",
          fontWeight: 900,
        }}
      >
        Bank Account {bankIndex}
      </Text>
      <Image
        src={HomeIcon}
        sx={{
          width: "36px",
          marginTop: "20px",
        }}
      ></Image>{" "}
      <Text
        sx={{
          color: "#333",
          textAlign: "center",
          fontFamily: "DIN-Black",
          fontSize: "20px",
          fontStyle: "normal",
          fontWeight: 900,
          marginTop: "5px",
        }}
      >
        {bank.bank_name}
      </Text>
      <Text
        sx={{
          color: "#333",
          textAlign: "center",
          fontFamily: "DIN",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 700,
          marginTop: "10px",
        }}
      >
        ··· ··· ·· {bank.last_4}
      </Text>
      <Image
        src={GoIcon}
        sx={{
          width: "12px",
          marginTop: "10px",
        }}
      ></Image>
    </Flex>
  );
};

export default BankCard;
